import request from "./request";

export default class TheftsService {
  static getTheftsInRadius(params: {
    lat: number;
    lng: number;
    start: string;
    end: string;
  }) {
    return request<{
      yearCounts: number;
      lastReportedMonthCount: number;
    }>({
      url: "/thefts/count/2",
      method: "GET",
      params,
    });
  }

  static checkCoordinates(params: { lat: number; long: number }) {
    return request<{
      id: number;
      countryId: number;
    }>({
      url: "/stats/check-coordinates",
      method: "GET",
      params,
    });
  }
}
